import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderByPipe } from '../../../../shared/pipe/order-by.pipe';

// services
import { UtilityService } from '../../../../core/services/utility.service';
import { AdminService } from '../../../../pages/admin/services/admin.service';

@Component({
  selector: 'app-preview-user-membership-modal',
  templateUrl: './preview-user-membership-modal.component.html',
  styleUrls: ['./preview-user-membership-modal.component.css'],
})
export class PreviewUserMembershipModalComponent implements OnInit {
  @Input() userGroupID: any;
  @Input() mode: string;
  @Input() name: string;

  nameFilter: string;
  isUpdatePersist: boolean;
  groupMembers: any;
  filteredMembers: any;
  filterBy: any;
  reverse: boolean;
  orderByPipe: OrderByPipe;
  isSafari = false;

  constructor(
    private activeModal: NgbActiveModal,
    private adminService: AdminService,
    private utilityService: UtilityService
  ) {
    this.orderByPipe = new OrderByPipe();
  }

  ngOnInit(): void {
    this.nameFilter = null;
    this.isUpdatePersist = this.mode == 'refresh';
    this.groupMembers = [];

    this.adminService.previewUserGroupMembers(this.userGroupID, this.isUpdatePersist).then((response: any[]) => {
      if (response != null) {
        this.groupMembers = response;
        this.filteredMembers = this.groupMembers;
      }
    });
    this.isSafari = this.utilityService.checkSafari();
  }

  exportExcel() {
    var name = this.name;
    name = name.replace(/[^0-9a-z]/gi, '');
    window.location.href =
      '/Admin/ExportUserGroupToExcel?userGroupID=' +
      this.userGroupID +
      '&isUpdatePersist=' +
      this.isUpdatePersist +
      '&userGroupName=' +
      name;
  }

  filterChanged() {
    this.filterMembers();
  }

  sortGrid(filterBy: any) {
    if (this.filterBy != filterBy) {
      this.filterBy = filterBy;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
    this.filteredMembers = this.orderByPipe.transform(this.filteredMembers, this.filterBy, this.reverse ? 'desc' : 'asc');
  }

  filterMembers() {
    var filteredMembers = [];
    if (this.nameFilter == null || this.nameFilter == '') {
      this.filteredMembers = this.groupMembers;
    } else {
      this.groupMembers.forEach(val => {
        if (val.EmployeeName?.toLowerCase().indexOf(this.nameFilter.toLowerCase()) > -1) {
          filteredMembers.push(val);
        }
      });
      this.filteredMembers = filteredMembers;
    }
  }

  closeClicked() {
    this.activeModal.close('close');
  }
}
